import React, { createElement, FC, useEffect, useRef } from 'react';
import { getDevEnv } from '../../service/envConfig';
import { getEnvironmentAppUrls } from '@dvag/dfs-constant-config';
import { getToken } from '@dvag/dfs-orchestrator-client';
import { useNavigate, useParams } from 'react-router-dom';
import { DxContainer, DxSpacer } from '@dvag/design-system-react';
import { createBridgeContext } from '@dvag/mfe-bridge';

export type KundenstammdatenElement = HTMLElement & {
  authenticationToken?: () => Promise<string | void>;
  haushaltId?: string;
  features?: string;
};

export type GetElement = KundenstammdatenElement | null;

const mfeBridgeIdentifier = 'kundenstammdatenNamensaenderung';

export const KundenstammdatenNamensaenderung: FC = () => {
  const { kundennummer } = useParams();
  const navigate = useNavigate();
  const isBridgeHandlerRegistered = useRef(false);

  const env = getDevEnv();
  const appUrls = getEnvironmentAppUrls(env);
  const scriptSrc = appUrls.kundenstammdaten + '/namensaenderung/namensaenderung-frontend.js';

  useEffect(() => {
    if (isBridgeHandlerRegistered.current) {
      return;
    }

    isBridgeHandlerRegistered.current = true;

    const bridge = createBridgeContext();
    const connectorKundenstammdaten = bridge.registerChildMFE(mfeBridgeIdentifier);

    const getElement = (): GetElement =>
      document.querySelector('dvag-kundenstammdaten-namensaenderung');

    const setLuigiAuthenticationProvider = (): void => {
      const element = getElement();
      if (!element) {
        return;
      }

      element.authenticationToken = () => Promise.resolve(getToken());
    };

    connectorKundenstammdaten.onConnection(() => setLuigiAuthenticationProvider());

    connectorKundenstammdaten.onEventFromMFE((eventName) => {
      if (eventName === 'close') {
        navigate(-1);
      }
      if (eventName === 'back') {
        navigate(-1);
      }
    });

    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.type = 'module';
      document.head.appendChild(script);
    }
  }, [navigate, scriptSrc]);

  const kssChangeName = createElement('dvag-kundenstammdaten-namensaenderung', {
    'mfe-bridge-identifier': mfeBridgeIdentifier,
    kundennummer,
  });

  return (
    <DxContainer
      type="page"
      color="transparent"
      data-testid="name-change-container"
      id="name-change-container"
    >
      <DxSpacer size="32v" />
      {kssChangeName}
    </DxContainer>
  );
};
